var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor"},[_c('vue-editor',{model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}),_vm._v(" "),_c('b-button',{attrs:{"outlinedNO":"","rounded":"","type":"is-info"},on:{"click":_vm.post}},[_c('span',[_vm._v(" Post")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }